// import { MapContainer, Marker, Popup, TileLayer, GeoJSON } from "react-leaflet";
// import "leaflet/dist/leaflet.css";
import React, { useState, useEffect } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { API } from "./App";
// import L from "leaflet";
import { useSearchParams } from "react-router-dom";
import { getAuthHeader } from "./AuthRoute";

// import proj4 from "proj4";
// import "proj4leaflet";
// import { CRS } from "leaflet";

// Define EPSG:2056
// const crs2056 = new L.Proj.CRS(
//   "EPSG:2056",
//   "+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 " +
//     "+k=1 +x_0=2600000 +y_0=1200000 +ellps=bessel " +
//     "+towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs",
//   {
//     resolutions: [
//       4000, 2000, 1000, 500, 250, 100, 50, 20, 10, 5, 2.5, 2, 1, 0.5,
//     ],
//     origin: [2420000, 1350000],
//   },
// );
// const epsg3857 = proj4.defs("EPSG:3857");
// // const epsg2056 = proj4.defs(
// //   "EPSG:2056",
// //   "+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 " +
// //     "+k=1 +x_0=2600000 +y_0=1200000 +ellps=bessel " +
// //     "+towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs",
// // );
// const EPSG2056 = proj4("EPSG:2056", "EPSG:4326");
//
// // proj4.defs(
// //   "EPSG:2056",
// //   "+proj=somerc +lat_0=46.95240555555556 +lon_0=7.439583333333333 " +
// //     "+k=1 +x_0=2600000 +y_0=1200000 +ellps=bessel " +
// //     "+towgs84=674.374,15.056,405.346,0,0,0,0 +units=m +no_defs",
// // );
//
// // Fix for default marker icons
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
//   iconUrl: require("leaflet/dist/images/marker-icon.png"),
//   shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
// });

const SearchPage = () => {
  const [searchParams] = useSearchParams();

  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  // const swissToWGS84 = (x, y) => {
  //   return EPSG2056.forward([2600000, 1200000]);
  //   return EPSG2056.forward([x, y]);
  //   //return proj4("EPSG:2056", "EPSG:3857", [x, y]);
  //   // return [lng, lat];
  // };

  useEffect(() => {
    const q = searchParams.get("query") || "";
    setQuery(q);
    if (q) {
      (async () => {
        await handleSearch(q);
      })();
    }
  }, [searchParams]);

  // const [data, setData] = useState([
  //   {
  //     type: "Feature",
  //     geometry: { type: "Point", coordinates: swissToWGS84(1191666, 2565775) },
  //     properties: {
  //       name: "R0926",
  //       url: "https://www.geocad1.vd.ch/index.php?lang=FR&view=sondage&mode=rapport&id=12348",
  //     },
  //   },
  //   {
  //     type: "Feature",
  //     geometry: { type: "Point", coordinates: swissToWGS84(1191666, 2565775) },
  //     properties: {
  //       name: "VD01234",
  //       url: "https://www.geocad1.vd.ch/index.php?lang=FR&view=sondage&mode=rapport&id=34062",
  //     },
  //   },
  // ]);
  // const position = [51.505, -0.09];
  //
  // // GeoJSON point styling
  // const pointToLayer = (feature, latlng) => {
  //   return L.marker(latlng, {
  //     icon: new L.Icon({
  //       iconUrl: require("leaflet/dist/images/marker-icon.png"),
  //       iconSize: [25, 41],
  //       iconAnchor: [12, 41],
  //       popupAnchor: [1, -34],
  //       shadowSize: [41, 41],
  //     }),
  //   });
  // };
  //
  // // GeoJSON popup content
  // const onEachFeature = (feature, layer) => {
  //   if (feature.properties && feature.properties.name) {
  //     layer.bindPopup(feature.properties.name);
  //   }
  // };
  const handleSearch = async (query) => {
    if (!query) return;

    setLoading(true);
    setError("");
    try {
      const encodedQuery = encodeURIComponent(query);
      const response = await fetch(
        API() + `/sondages/search?query=${encodedQuery}`,
        {
          headers: {
            Authorization: getAuthHeader(),
          },
        },
      );
      if (!response.ok) {
        throw new Error("No results found or error occurred");
      }
      const data = await response.json();
      // sort data so that the first one is the most relevant, meaning contains the query in the sondage_url's &id=
      data.sort((a, b) => {
        const aId = a.sondage_url.split("&id=")[1];
        const bId = b.sondage_url.split("&id=")[1];
        return aId === query ? -1 : bId === query ? 1 : 0;
      });

      setResults(data);
      const swissToWGS84 = (x, y) => {
        const lat = ((y - 600000) / 1000000) * 5.4 + 46.0;
        const lng = ((x - 200000) / 1000000) * 5.4 + 6.0;
        return [lng, lat];
      };

      const geoJsonData = {
        type: "FeatureCollection",
        features: data.map((item) => {
          // Ensure you're using the correct coordinate order
          // GeoJSON expects [longitude, latitude]
          const coordinates = item.position
            ? [item.position.y, item.position.x]
            : [0.1, 0.1]; // fallback if no position

          return {
            type: "Feature",
            geometry: {
              type: "Point",
              coordinates: coordinates,
            },
            properties: {
              name: item.sondage_name || "Unnamed Sondage",
              url: item.sondage_url || "#",
            },
          };
        }),
      };
      console.log(geoJsonData);
      // setData(geoJsonData);
    } catch (err) {
      setError(err.message);
      setResults([]);
      // setData(null);
    } finally {
      setLoading(false);
    }
  };
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch(query);
    }
  };

  return (
    <div className="search-container">
      <div className="search-bar">
        <input
          type="text"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyPress={handleKeyPress} // Add the keypress listener
          placeholder="Search for sondage name or URL"
          className="search-input"
        />
        <button onClick={() => handleSearch(query)} className="search-button">
          Search
        </button>
      </div>

      {loading && (
        <div className="loading-indicator">
          <ProgressSpinner style={{ width: "50px", height: "50px" }} />
        </div>
      )}

      {error && <p className="error-message">{error}</p>}

      <ul className="results-list">
        {results.length > 0
          ? results.map((item) => (
              <li key={item._id} className="result-item">
                <a
                  href={`/all-sondages/sondage/${item._id}/docnbr/0`}
                  // target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.sondage_url} {item.sondage_name}
                </a>
              </li>
            ))
          : !loading && <p>No results found</p>}
      </ul>

      {/*<div className="map">*/}
      {/*  <MapContainer*/}
      {/*    center={position}*/}
      {/*    zoom={6}*/}
      {/*    scrollWheelZoom={true}*/}
      {/*    style={{ height: "500px", width: "100%" }}*/}
      {/*  >*/}
      {/*    <TileLayer*/}
      {/*      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'*/}
      {/*      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"*/}
      {/*    />*/}

      {/*    /!* Render GeoJSON data with proper styling *!/*/}
      {/*    {data && (*/}
      {/*      <GeoJSON*/}
      {/*        data={data}*/}
      {/*        pointToLayer={pointToLayer}*/}
      {/*        onEachFeature={onEachFeature}*/}
      {/*      />*/}
      {/*    )}*/}
      {/*  </MapContainer>*/}
      {/*</div>*/}
    </div>
  );
};

export default SearchPage;
